import { createFileRoute, Outlet } from '@tanstack/react-router';
import RequestsPage from '../../../features/bed-management/pages/RequestsPage';
import { getRequestsQueryOptions, getUnitsQueryOptions } from '../../../features/bed-management/queries';

export const Route = createFileRoute('/_auth/bed-management/requests')({
  component: RouteComponent,
  loader: async ({ context }) => {
    const { user, healthCenter } = context.authenticationContext;
    if (!user || !healthCenter) {
      return;
    }

    const userUnitIds = user.units?.map((unit) => unit.id) || [];

    const units = await context.queryClient.ensureQueryData(
      getUnitsQueryOptions('bedManagement', healthCenter, userUnitIds)
    );

    if (units.length > 0) {
      await context.queryClient.ensureQueryData(getRequestsQueryOptions(units));
    }
  },
});

function RouteComponent() {
  const { user, healthCenter } = Route.useRouteContext().authenticationContext;
  const userUnitIds = user?.units?.map((unit) => unit.id) || [];

  return (
    <>
      <RequestsPage userUnitIds={userUnitIds} healthCenter={healthCenter} />
      <Outlet />
    </>
  );
}
